export enum ESocialNetworks {
  BLOGGER = 'blogger',
  DELICIOUS = 'delicious',
  DIGG = 'digg',
  EVERNOTE = 'evernote',
  MESSENGER = 'messenger',
  LINKEDIN = 'linkedin',
  LJ = 'lj',
  MOIMIR = 'moimir',
  ODNOKLASSNIKI = 'odnoklassniki',
  PINTEREST = 'pinterest',
  POCKET = 'pocket',
  QZONE = 'qzone',
  REDDIT = 'reddit',
  RENREN = 'renren',
  SINAWEIBO = 'sinaWeibo',
  SKYPE = 'skype',
  SURFINGBIRD = 'surfingbird',
  TELEGRAM = 'telegram',
  TENCENTWEIBO = 'tencentWeibo',
  TUMBLR = 'tumblr',
  TWITTER = 'twitter',
  VIBER = 'viber',
  VKONTAKTE = 'vkontakte',
  WHATSAPP = 'whatsapp',
}
